import Big from 'big.js';

import { addComma } from '~/utils';
import { rate2Percent } from '~/utils/rate2percent';

export const formatRate = (rate: Big | number): string => {
  return rate2Percent(rate, 1, true);
};

export const formatAmount = addComma;

export const formatPoint = (num: Big | number, isRate: boolean): string => {
  return isRate ? formatRate(num) : addComma(num);
};
